import axios from 'axios';
import { postRequest } from 'services/requests';
import { getSubmissionFileWithRecovery } from 'utils/submissionFileRecovery';

const services = {
    getAssignments: (body) => postRequest(`/get-assignments`, body),
    getAssignment: (body) => postRequest(`/get-assignment`, body),
    getEnvData: (body) => postRequest(`/get-sections`, body),
    getCourseUsers: (body) => postRequest(`/get-course-users`, body),
    getSubmissions: (body) => postRequest(`/get-submissions`, body),
    getSubmissionFile: (body, options) =>
        getSubmissionFileWithRecovery(
            // Read at send time: queued files, retries, and polls may outlive a token refresh.
            (payload, config) =>
                axios.post(
                    '/get-submission-file',
                    { ...payload, accessToken: localStorage.getItem('access_token') },
                    config
                ),
            body,
            options
        ),
    // Long grade pushes can outlive a token refresh; read the token for each request and retry.
    postGrade: (body) => postRequest(`/post-grade`, { ...body, accessToken: localStorage.getItem('access_token') }),
    pushRubric: (body) => postRequest(`/push-rubric`, body),
    listAPIUsers: (body) => postRequest(`/list-api-users`, body),
    createAPICourse: (body) => postRequest(`/create-course`, body),
    getCourseById: (body) => postRequest(`/get-course-by-id`, body),
    getAPICourses: (body) => postRequest(`/get-courses`, body),
};

export default services;
